import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

export default function Banner() {
  return (
    <div className="grid">
      <StaticImage
        style={{
          gridArea: '1/1',
          clipPath: 'polygon(60% 0, 100% 0%, 100% 100%, 40% 100%)',
        }}
        layout="fullWidth"
        alt=""
        src="../../images/home-banner.jpg"
        formats={['auto', 'webp', 'avif']}
        className="h-screen w-full md:block hidden"
      />
      <StaticImage
        style={{
          gridArea: '1/1',
          filter: `grayscale(1)`,
        }}
        layout="fullWidth"
        alt=""
        src="../../images/home-banner.jpg"
        formats={['auto', 'webp', 'avif']}
        className="h-screen w-full block md:hidden"
      />
      <div
        style={{
          // By using the same grid area for both, they are stacked on top of each other
          gridArea: '1/1',
          position: 'relative',
          placeItems: 'center',
          display: 'grid',
        }}
        className="h-screen w-full"
      >
        <div className="md:relative md:top-0 md:left-0 w-full p-0 m-0 z-0 mb-4">
          <div className="relative z-0 w-full h-full">
            <div className="text-white md:text-gray-700 px-8 pl-16 w-full md:w-1/2 h-full flex flex-col flex-wrap justify-center z-10 relative ">
              <h2 className="text-6xl font-bold uppercase">SVRID</h2>
              <h1 className="mb-4">
                Sociedad Venezolana de Radiología
                <br />e Imagenología Dentomaxilofacial
              </h1>
              <p className="my-2 text-sm">{/*  */}</p>
              <div className="mt-4">
                <Link
                  to="/beneficios-y-afiliacion"
                  className="bg-blue-700 shadow-xl rounded-lg px-5 py-3 w-auto font-semibold text-gray-50 uppercase"
                >
                  Únete
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
